/**
 * @generated SignedSource<<4522408bce17ed0cf199cd88aa9f6bca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type auth_getRedirectPath$data = {
  readonly confirmedEmail: boolean | null | undefined;
  readonly integrationName: string | null | undefined;
  readonly status: UserStatus | null | undefined;
  readonly unconfirmedEmail: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"auth_getDefaultPath" | "user_isClient" | "user_isGuest" | "user_isMember">;
  readonly " $fragmentType": "auth_getRedirectPath";
};
export type auth_getRedirectPath$key = {
  readonly " $data"?: auth_getRedirectPath$data;
  readonly " $fragmentSpreads": FragmentRefs<"auth_getRedirectPath">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "auth_getRedirectPath"
};

(node as any).hash = "14dbff61874064a209826cefc0afb2e5";

export default node;
